<footer class="footer">
  <p>
    © {{ currentYear }} Fake News Combat. All rights reserved.
    <a
      href="https://www.youtube.com/@FakeNewsCombat"
      target="_blank"
      aria-label="YouTube"
      class="youtube"
    >
      <i class="fa-brands fa-youtube"></i>
    </a>

    <a
      href="https://www.tiktok.com/@fakenewscombat"
      target="_blank"
      aria-label="TikTok"
      class="tiktok"
    >
      <i class="fa-brands fa-tiktok"></i>
    </a>

    <a
      href="https://www.facebook.com/profile.php?id=61589875980591"
      target="_blank"
      aria-label="Facebook"
      class="facebook"
    >
      <i class="fa-brands fa-facebook-f"></i>
    </a>

    <a href="https://x.com/fakenewscombat" target="_blank" aria-label="X" class="x">
      <i class="fa-brands fa-x-twitter"></i>
    </a>
  </p>
</footer>
